
try {
    window.$ = window.jQuery = require('jquery');

    //require('jquery-ui/ui/effects/effect-slide.js');
    //require('jquery-ui/ui/widgets/datepicker.js');
    //require('jquery-ui/ui/i18n/datepicker-hr.js');
    require('@popperjs/core');
    window.bootstrap = require('bootstrap');
    window.Modal = require('bootstrap/js/dist/modal');

    window.dt = require('datatables.net');

    window.$('.table-datatables').DataTable({
        "lengthMenu": [ 10, 15, 25, 50 ],
        "pageLength": 15,
        "language": {
            "lengthMenu": "Prikaži _MENU_ rezultata po stranici",
            "zeroRecords": "Ništa nije pronađeno!",
            "info": "Stranica _PAGE_ od _PAGES_ od _TOTAL_ rezultata",
            "search": "Pretraga",
            "infoEmpty": "Nema rezultata.",
            "infoFiltered": "(filtrirano od _MAX_ ukupnih rezultata)",
            "paginate": {
                "next": "Sljedeća",
                "previous": "Prethodna"
            }
        }
    });

    require('./http.js');

    // otvori tab prema linku
    openTab();

    window.addEventListener('hashchange', function(){
        openTab();
    })
    /*window.Popover = require('bootstrap/js/dist/popover');
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new Popover(popoverTriggerEl)
    });*/

    function openTab() {
        var url = document.location.toString();
        if (url.match('#')) {
            var tabEl = document.querySelector('#user-navigation a[href="#'+url.split('#')[1]+'"]');
            var tab = new bootstrap.Tab(tabEl);
            console.log(tab);
            tab.show();
        }
    }

    
 

} catch (e) {}
